import {Component, OnInit, ViewChild} from '@angular/core';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { EfileService } from 'src/app/services/efile.service';
import { CaseService } from 'src/app/services/case.service';
import { DictionaryService } from 'src/app/services/dictionary.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { DatePipe } from '@angular/common';

import { EFilePaymentDto } from 'src/app/application/efile/dto/efile-payment.dto';
import {Table} from "primeng/table";


@Component({
    selector: 'efiling-view',
    templateUrl: './efiling-view.component.html',
})

export class EfileViewComponent implements OnInit {
  @ViewChild('efileCases', { static: false}) efileCasesTable!: Table; // provides access to the p-table
  filterEvent: any = null;  // will store the applied filters and use them to restore previous list

    myYear: number;
    myEfileId: string;
    myApplicant: any;
    myAgency: any;
    myProperty: any;
    myValue: any;
    myFacts: any;
    myPayment: any;
    //
    yearList: string[];
    paymentList: EFilePaymentDto[]; // will contain ALL payment transactions collected by EFiling
    applicationList: any[];
    loadedStatuses = 0;
    selectedCases: any[];
    searchString: any;
    efiledData: any;
    cols: any[];
    statuses: any[];
    //
    dictionaryList: any;
    statusList: [];
    subStatusList: [];
    cityList: string[];
    payStatusList: any[];   // payment statuses (from EFiling)
    appealsTypeList: any[];

    displayState: any = {
        indexDiv: false,
        workingDiv: false,
        gridDiv: false,
        detailsDiv: false,
    };

    filterOptions: any = {
        filterText: '',
    };

    filterEventCount: 0;
  constructor(private messageService: MessageService, private efileService: EfileService, private caseService: CaseService,
                private dictService: DictionaryService, private confirmationService: ConfirmationService, private datePipe: DatePipe,
                private utilService: UtilitiesService) { }

    ngOnInit() {
      this.cols = [
        { field: 'dateUpdated', header: 'Dt Updated' },
        { field: 'username', header: 'User Name'},
        { field: 'filingStatus', header: 'Status'},
        { field: 'applicantName', header: 'Applicant'},
        { field: 'parcelNumber', header: 'APN'},
        { field: 'propertyLocationView', header: 'Situs or Location'},
        { field: 'agentName', header: 'Agent' },
        { field: 'applicationNumber', header: 'Case#'},
        { field: 'typeOfAssessment', header: 'Type'},
      ];
      this.statuses = [
        { label: 'Submitted', value: 'Submitted' },
        { label: 'In Progress', value: 'InProgress'},
        { label: 'Accepted', value: 'Accepted'},
        { label: 'Withdrawn', value: 'Withdrawn'},
        { label: 'Rejected', value: 'Rejected'},
        { label: 'Withdrawn-Cur', value: '5'},
        { label: 'Rejected-Cur', value: '6'},
      ];
      // this.searchString = { applicantName: '', agentName: '' };
      this.efiledData = null;


      // get Dictionaries - NEEDED??
      this.dictionaryList = this.dictService.getDictionaries();
      this.statusList = this.dictionaryList.statusChoices;
      this.subStatusList = this.dictionaryList.subStatusChoices;
      this.cityList = this.dictionaryList.cityChoices;
      this.payStatusList = this.dictionaryList.paymentStatusTypes;
      // this.appealsTypeList = this.dictionaryList.assessTypes;
      // ['Regular', 'Supplemental', 'Roll Change', 'Escape', 'Calamity', 'Penalty'];
      this.appealsTypeList = [
        { label: 'Regular', value: 'Regular'},
        { label: 'Supplemental', value: 'Supplemental'},
        { label: 'Roll Change', value: 'Roll Change'},
        { label: 'Escape', value: 'Escape'},
        { label: 'Calamity', value: 'Calamity'},
        { label: 'Penalty', value: 'Penalty'}
      ]
        // this.utilService.doAudit(this.dictionaryList);

        // finally, get list of applications E-filed during specified year...
        this.getYearList();
        // this.utilService.doAudit('going to initialize Bernie');
        // this.efileService.initBernie();
        this.getEfiledAppList(false);
        // this.activateFuncAPI();
    }
// generate a list of years to display, based on current year (for now, allow users to go back 5 years)
    getYearList() {
        this.yearList = [];
        const calYear = new Date().getFullYear();
        const baseYr = calYear - 5;
        for (let yr = calYear; yr > baseYr; yr--) {
        this.yearList.push(yr.toString());
        }
        this.myYear = this.myYear ? this.myYear : calYear;
        // this.doaudit(this.yearList);
    }

    selectYear(ev: Event) {
        this.utilService.doAudit('Select Year Event: ' + ev);
        this.getEfiledAppList(true);
    }

    // get list of ALL applications Efiled (with specific Filing Statuses)
    getEfiledAppList(clearFilters: boolean = false) {
        this.displayState.indexDiv = false;
        this.displayState.detailsDiv = false;
        this.displayState.workingDiv = true;
        this.loadedStatuses = 0;
        this.filterOptions.filterText = '';
        this.filterEventCount = 0;
        this.filterEvent = null;
        const calYear = this.myYear ? this.myYear : new Date().getFullYear();
        this.applicationList = [];  // initialize application array
        // this.efileCasesTable.clear(); // clear the table, filters
        for (let filStatus = 6; filStatus > 0 ; --filStatus) {
            this.getAppsForStatus(filStatus, calYear);
        }
        // clear filters
        // NOTE: done once all the statuses (above) have been retrieved AND the table is visible (WorkingDiv = false)
        if (clearFilters) {
          this.clearTable(this.efileCasesTable);
        }
    }

    getAppsForStatus(fileStatus: number, calYear: number) {
        this.efileService.getApplicationList(calYear.toString(), fileStatus).subscribe(data => {
            this.utilService.doAudit('returned from getting cases for year: ' + calYear + '; status: ' + fileStatus);
            this.utilService.doAudit(data);
            if (data.length > 0) {
                let loc = '';
                for (let i = 0; i < data.length; i++) {
                    if (data[i].propertyLocation) {
                        loc = data[i].propertyLocation;
                    } else {
                        loc = data[i].streetNumber ? data[i].streetNumber : '';
                        if (data[i].streetAddress) {
                            loc = (loc ? (loc + ' ') : '') + data[i].streetAddress;
                        }
                        if (data[i].unit) {
                            loc = loc + ' unit ' + data[i].unit;
                        }
                    }
                    data[i].propertyLocationView = loc;
                    // ***** why is agentName NULL for all applications?? - review API service (are users identifying as applicants, not agents??) *****
                    if (data[i].agentName === ', ') {
                        data[i].agentName = '';
                    }
                    if (data[i].dateUpdated) {
                        data[i].dateUpdated = this.utilService.convertUTCtoLocal(data[i].dateUpdated);
                    }
                  if (data[i].typeOfAssessmentId) {
                    data[i].typeOfAssessment = this.appealsTypeList[data[i].typeOfAssessmentId - 1].value;
                  }
                    this.applicationList.push(data[i]);
                }
            }
            ++this.loadedStatuses;
            if (this.loadedStatuses === 4) {
                // sort list of applications based on the applicationId, in reverse order; might want to apply a different sort??
                this.applicationList.sort((a, b) => {
                    if (a.applicationId < b.applicationId) { return 1; }
                    else if (a.applicationId > b.applicationId) { return -11; }
                    else { return 0; }
                });
                this.displayState.workingDiv = false;
                this.displayState.indexDiv = true;
            }
        });
    }

    // view application data (in non-PDF form)
    viewApplication(row: any) {
        this.myEfileId = row.applicationId;
        this.utilService.doAudit('ready to display application details');
        this.utilService.doAudit(row);
        this.displayState.indexDiv = false;
        this.displayState.detailsDiv = true;
    }

    exitDetails() {
        this.displayState.detailsDiv = false;
        // *** FOR NOW:  clear filter text and initialize filter count
        // *** FIND WAY TO RETAIN FILTERED SET, IF ANY
        // this.filterOptions.filterText = '';
        //
      this.displayState.workingDiv = false;
        this.displayState.indexDiv = true;
      this.utilService.doAudit( this.filterEvent, 'exit details; filtered valued:');
      this.utilService.doAudit(this.efileCasesTable, 'table:');
      if (this.filterEvent != null && this.efileCasesTable) {
        this.efileCasesTable.filters = this.filterEvent;
        this.efileCasesTable.filteredValue = this.filterEvent.filteredValue;
        this.filterEventCount = this.filterEvent.filteredValue.length;
      } else {
        this.filterEventCount = 0;
        this.filterOptions.filterText = '';
      }
        // this.searchString = { applicantName: '', agentName: '' };
    }

    getEfiledApplication(efileId: any) {
        this.utilService.doAudit('getting application; efileId: ' + efileId);
        this.efileService.getEfiledApplication(efileId).subscribe(data => {
            this.utilService.doAudit(data);
            this.efiledData = data;
            // NOTE:   ReceivedDate is CORRECT, i.e. handles Time Zone; SEE CASES 2020-001 - 2020-003
            let applicantName = this.efiledData.applicationApplicantDto.lastName;
            if (this.efiledData.applicationApplicantDto.firstName) { applicantName = applicantName + ', ' + this.efiledData.applicationApplicantDto.firstName; }
            if (this.efiledData.applicationApplicantDto.middleInitial) { applicantName = applicantName + ' ' + this.efiledData.applicationApplicantDto.middleInitial; }
            this.efiledData.applicantFullName = applicantName;
            // this.searchString.applicantName = this.efiledData.applicationApplicantDto.lastName;  //applicantName;
            this.utilService.doAudit('leaving getEfiledApplication; applicant name: ' + this.efiledData.applicantFullName);
            this.displayState.workingDiv = false;
            this.displayState.detailsDiv = true;
        });
    }
// display a PDF version of the original Application
    viewAppPDF(row: any) {
        if (!row.applicationId) {
            this.showToast({ key: 'info', severity: 'error', detail: 'Sorry, there is a problem with this application. Please notify technical support.', summary: 'Error:' });
            return;
        }

        const myId = this.utilService.genEncryptId(row.applicationId);
        let xURL = this.utilService.getCreatePdfUrl();
        xURL = xURL + myId;
        // open a window/tab
        window.open(xURL, '_blank');

    }

    getTodaysDate() {
        const today = new Date();
        const dd = today.getDate();
        const mm = today.getMonth() + 1; // January is 0!
        const yyyy = today.getFullYear();
        let tDay = '', tMonth = '', tToday = '';
        if (dd < 10) {
            tDay = '0' + dd;
        }
        if (mm < 10) {
            tMonth = '0' + mm;
        }
        tToday = mm + '/' + dd + '/' + yyyy;
        return tToday;
    }

    getTodaysYear() {
        const yyy = new Date().getFullYear;
        return yyy;
    }

    stripDashes(x) {
        if (x === null || x === undefined) {
            return '';
        }
        return x.toString().replace(/-/g, '');
    }

    // run when table is filtered; capture # of displayed rows
    onFilter(event, dt) {
        this.utilService.doAudit(event, 'onFilter event');
        this.utilService.doAudit(this.efileCasesTable, 'table:');
        this.filterEvent = event;  // store the current filters
        this.filterEventCount = event.filteredValue.length; // count of displayed rows
    }
    // clear filters applied to table
    clearTable(table: any) {
      table.clear();
    }

    // Mapping Methods

    // Toaster-related methods
    showToast(msg: Message) {
        this.messageService.add(msg);
      }


    clear() {
        this.messageService.clear();
    }

}
